// import global variable
import variables from "./components/variables";

// jquery and bootstrap is main library of this app.
try {
    window.$ = window.jQuery = require('jquery');

    // setup ajax call for csrf token
    $.ajaxSetup({
        headers: {
            "X-CSRFToken": variables.csrfToken
        }
    });

    // load library
    require('bootstrap');
    window.moment=require('moment');
    require('daterangepicker');
    require('jquery-validation');
    require('select2');
    require('floatthead');
    require('jquery-mask-plugin');

    // load scripts
	require('./scripts/currency-value');
    require('./scripts/validation');
    require('./scripts/custom-upload-button');
    require('./scripts/one-touch-submit');
    require('./scripts/table-responsive');
    require('./scripts/off-canvas');
} catch (e) {}

// import another libraries regarding templates and forms
// pointing to direct js in template
// // another option is download library package independently and import as module
// require('../../../node_modules/Star-Admin-Free/vendors/js/vendor.bundle.base');
// require('../../../node_modules/Star-Admin-Free/vendors/js/vendor.bundle.addons');
require('icheck');

// import main global component for initialization and theme
import libs from './libs';
libs();

import notification from './components/notification';
notification();

// import pages scripts (the function modules automatically executed when imported)
// another option, include the script specific pages where they are needed for optimization
if ($('.upload-wrapper').length) {
	import("./components/file-uploader").then(fileUploader => fileUploader.default());
}
if ($('#form-role').length) {
    import("./pages/role").then(role => role.default());
}
if ($('#form-department').length) {
    import("./pages/department").then(department => department.default());
}
if ($('#form-roe-type').length) {
    import("./pages/roe-type").then(roeType => roeType.default());
}
if ($('#form-sort-document-type').length) {
    import("./pages/sort-document-type").then(sortDocumentType => sortDocumentType.default());
}
if ($('#form-applicant').length || $('#table-applicant').length) {
    import("./pages/applicant").then(applicant => applicant.default());
}
if ($('#form-iq-test').length) {
    import("./pages/iq-test").then(iqTest => iqTest.default());
}
if ($('#form-test').length) {
    import("./pages/disc-test").then(disctest => disctest.default());
}
if ($('#form-test-papikostik').length) {
    import("./pages/papikostik-test").then(papikostikTest => papikostikTest.default());
}
if ($('#form-employee-request').length || $('#table-employee-request').length || $('#form-add-applicant').length) {
    import("./pages/employee-request").then(employeeRequest => employeeRequest.default());
}
if ($('#table-employee-mutation').length || $('#form-employee-mutation').length) {
    import("./pages/employee-mutation").then(employeeMutation => employeeMutation.default());
}
if ($('#form-employee-pkwt').length) {
    import("./pages/employee-pkwt").then(employeePkwt => employeePkwt.default());
}
if ($('#form-employee-detail').length) {
    import("./pages/employee-detail").then(employeeDetail => employeeDetail.default());
}
if ($('#table-employee-detail-request').length) {
    import("./pages/employee-detail-request").then(employeeDetailRequest => employeeDetailRequest.default());
}
if ($('#form-employee').length || $('#table-employee').length) {
    import("./pages/employee").then(employee => employee.default());
}
if ($('#form-document-checklist').length) {
    import("./pages/employee-document-checklist").then(employeeDocumentChecklist => employeeDocumentChecklist.default());
}
if ($('#form-hire-employee').length || $('#candidate-wrapper').length) {
    import("./pages/employee-applicant").then(employeeApplicant => employeeApplicant.default());
}
if ($('#form-absent').length || $('#table-absent').length) {
    import("./pages/absent").then(absent => absent.default());
}
if ($('#table-absent-acknowledge').length) {
    import("./pages/absent-acknowledge").then(absentAcknowledge => absentAcknowledge.default());
}
if ($('#form-overtime').length || $('#table-overtime').length) {
    import("./pages/overtime").then(overtime => overtime.default());
}
if ($('#table-report-overtime-summary').length) {
    import("./pages/overtime-summary").then(overtime => overtime.default());
}
if ($('#table-report-overtime-weekly').length) {
    import("./pages/overtime-weekly").then(overtime => overtime.default());
}
if ($('#table-attendance').length) {
    import("./pages/attendance").then(attendance => attendance.default());
}
if ($('#table-create-schedule-operational').length) {
    import("./pages/schedule-division").then(scheduleDivision => scheduleDivision.default());
}
if ($('#modal-delete').length) {
    import("./components/delete").then(modalDelete => modalDelete.default());
}
if ($('.btn-validate').length && $('#modal-validate').length) {
	import("./components/validate").then(modalValidate => modalValidate.default());
}
if ($('#form-cut-off').length || $('#table-cut-off-salary').length) {
    import("./pages/cut-off").then(cutOff => cutOff.default());
}
if ($('#form-schedule').length) {
    import("./pages/schedule").then(schedule => schedule.default());
}
if ($('#form-schedule-division').length) {
    import("./pages/schedule-division").then(scheduleDivision => scheduleDivision.default());
}
if ($('#form-position').length) {
    import("./pages/position").then(position => position.default());
}
if ($('#form-assessment-type').length) {
    import("./pages/assessment-type").then(assessmentType => assessmentType.default());
}
if ($('#form-applicant-assessment').length) {
    import("./pages/applicant-assessment").then(applicantAssessment => applicantAssessment.default());
}
if ($('#form-accuracy').length || $('#table-point').length) {
    import("./pages/accuracy").then(accuracy => accuracy.default());
}
if ($('#employee-work-schedule').length) {
    import("./pages/work-schedule").then(employeeSchedule => employeeSchedule.default());
}
if ($('#form-salary-component').length) {
    import("./pages/salary-component").then(salaryComp => salaryComp.default());
}
if ($('#form-salary-component-summary').length) {
    import("./pages/salary-component-summary").then(salaryComponentSummary => salaryComponentSummary.default());
}
if ($('#table-report-late-summary').length) {
    import("./pages/report").then(report => report.default());
}
if ($('#form-broadcast').length || $('#table-broadcast').length) {
    import("./pages/broadcast").then(broadcast => broadcast.default());
}
if ($('#form-shift').length) {
    import("./pages/shift").then(shift => shift.default());
}
if ($('#attendance-device-api').length) {
    import("./pages/attendance-device").then(attendanceDevice => attendanceDevice.default());
}
if ($('#waiting-webhook-response').length) {
    import("./pages/webhook-response").then(webhookResponse => webhookResponse.default());
}
if ($('#modal-validate-employee-operational').length) {
    import("./pages/schedule-division").then(scheduleDivision => scheduleDivision.default());
}
if ($('#form-work-location').length) {
    import("./pages/work-location").then(workLocation => workLocation.default());
}
if ($('#form-document-disposition').length || $('#table-document-disposition').length) {
    import("./pages/document-disposition").then(documentDisposition => documentDisposition.default());
}
if ($('#form-turnover-report').length) {
    import("./pages/report-turnover").then(turnover => turnover.default());
}
if ($('#form-meeting-zoom').length || $('#table-meeting-zoom').length) {
    import("./pages/meeting-zoom").then(meetingZoom => meetingZoom.default());
}
if ($('#form-overtime-request').length || $('#table-overtime-request').length) {
    import("./pages/overtime-request").then(overtimeRequest => overtimeRequest.default());
}
if ($('#form-payroll-adjustment').length) {
    import("./pages/payroll-adjustment").then(payrollAdjustment => payrollAdjustment.default());
}
if ($('#chatbot-wrapper').length) {
    import("./pages/chatbot").then(chatbot => chatbot.default());
}
if ($('#form-chatbot-knowledge').length) {
    import("./pages/chatbot-knowledge").then(chatbotKnowledge => chatbotKnowledge.default());
}

// include sass (but extracted by webpack into separated css file)
import '../sass/plugins.scss';
import '../sass/app.scss';
